import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, makeStyles, withStyles } from '@material-ui/core';
import { pad } from 'lodash';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minWidth: '1280px',
        overflow: 'auto',
        height: 'calc(100vh - 235px)'
    },
    headerCell: {
        fontWeight: 600,
        height: 30,
        borderRight: '1px solid #ddd'
    },
    bodyCell: {
        height: 30,
        borderRight: '1px solid #eee'
    },
    noRows: {
        textAlign: 'center',
        padding: '20px',
        color: '#888',
        fontSize: 14
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'lightGrey',
        color: 'black',
        padding: '0px 6px'
    },
    body: {
        fontSize: 14,
        padding: '0px 6px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            // backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

export default function UserManagementTable({ columns, rows }) {
    const classes = useStyles();

    return (
        <TableContainer className={classes.root}>
            <Table stickyHeader size="small">
                {/* Table Head */}
                <TableHead>
                    <TableRow>
                        {columns.map((col) => (
                            <StyledTableCell key={col.field} className={classes.headerCell} width={col.width}>
                                {col.headerName}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>

                {/* Table Body */}
                <TableBody>
                    {rows.length > 0 ? (
                        rows.map((row, index) => (
                            <StyledTableRow key={index} hover>
                                {columns.map((col) => (
                                    <StyledTableCell key={col.field} className={classes.bodyCell}>
                                        {col.renderCell ? col.renderCell(row) : col.valueGetter ? col.valueGetter(row[col.field]) : row[col.field] ?? '-'}
                                    </StyledTableCell>
                                ))}
                            </StyledTableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columns.length} className={classes.noRows}>
                                {/* Custom No Rows Overlay */}
                                No Records Found
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
